import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import {
  CanAccess,
  AuthorizationList,
} from "../../components/template/authorization/Authorization";

export const initFilterInput = {
  searchName: "",
  page: 1,
  pageSize: 10,
};

export const initForm = {
  type: "internal",
  status: "active",
};

export const renderColumns = (handleEdit, handleDelete) => {
  return [
    {
      dataIndex: "outletCode",
      key: "outletCode",
      title: "Kode Outlet",
      width: "7%",
    },
    {
      dataIndex: "tipe",
      key: "tipe",
      title: "Jenis Outlet",
    },
    {
      dataIndex: "name",
      key: "name",
      title: "Nama Outlet",
    },
    {
      dataIndex: "address",
      key: "address",
      title: "Alamat",
      width: "40%",
    },
    {
      dataIndex: "commission",
      key: "commission",
      title: "Komisi",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.update_outlet}
            yes={
              <div className="mr-2" onClick={() => handleEdit(record)}>
                <BiEditAlt
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
          <CanAccess
            role={AuthorizationList.delete_outlet}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
